import { useQuery } from '@tanstack/react-query';
import type { AuthUserDto, AuthTenantDto } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface MeApiResponse {
  success: boolean;
  data: {
    user: AuthUserDto;
    tenant: AuthTenantDto;
  };
}

/**
 * Query hook for retrieving the current user's authenticated context.
 * Calls GET /auth/me.
 */
export function useMe(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.auth.me(),
    queryFn: async () => {
      const response = await apiClient.get<MeApiResponse>('/auth/me');
      return response.data.data;
    },
    ...options,
  });
}
